export default __webpack_public_path__ + "static/media/chatIcon.e07b79ed.svg";